/** FAQ, Support, and Advertising page copy (Estonian). */
export const pagesMessagesEt = {
  faq: {
    pageTitle: "Korduma kippuvad küsimused",
    pageSubtitle: "Leidke vastused WasOKi kohta sagedamini esitatud küsimustele",
    seoTitle: "KKK — WasOK",
    seoDescription:
      "Vastused sagedamini esitatud küsimustele WasOKi, toodete skannimise, privaatsuse ja hinnangute kohta.",
    items: [
      {
        question: "Kuidas WasOK töötab?",
        answer:
          "WasOK aitab teil meeles pidada, millised tooted teile meeldisid või ei meeldinud, skannides vöötkoode ning salvestades teie hinnangud ja märkmed. Skannige lihtsalt toote vöötkood, hinnake seda, lisage märkmeid, ja järgmisel korral sama toodet skannides näete kohe oma varasemat hinnangut.",
      },
      {
        question: "Kas mu andmeid hoitakse pilves?",
        answer:
          "Ei! Kõik teie andmed salvestatakse kohalikult teie seadmesse. Me ei sünkrooni teie teavet pilve, mis tähendab, et teie ostuajalugu ja tootearvamused jäävad täiesti privaatseks. See tähendab aga ka seda, et peaksite oma seadmest varukoopiaid tegema, kui soovite oma andmeid säilitada.",
      },
      {
        question: "Kas WasOKi kasutamiseks on vaja internetiühendust?",
        answer:
          "Ei, WasOK töötab täiesti võrguühenduseta. Kuna kõik teie andmed salvestatakse kohalikult teie seadmesse, saate skannida tooteid, lisada hinnanguid ja vaadata oma ajalugu ilma internetiühenduseta.",
      },
      {
        question: "Kas ma saan WasOKi kasutada mis tahes tüüpi toodete jaoks?",
        answer:
          "Jah! WasOK töötab iga tootega, millel on vöötkood. Olgu selleks toit, kosmeetika, majapidamistarbed, elektroonika või mis tahes muu vöötkoodiga ese, saate selle skannida ja oma arvamuse salvestada.",
      },
      {
        question: "Kuidas ma vöötkoodi skannin?",
        answer:
          "Lihtsalt avage WasOKi rakendus ja puudutage skannimisnuppu. Suunake kaamera toote vöötkoodile ning rakendus tuvastab ja skannib selle automaatselt. Parimate tulemuste saavutamiseks veenduge, et vöötkood on hästi valgustatud ja fookuses.",
      },
      {
        question: "Kas ma saan oma tootehinnangutele lisada fotosid?",
        answer:
          "Jah! Igale tootearvustusele saate lisada fotosid. See on eriti kasulik pakendi üksikasjade, koostisainete loendite või muu visuaalse teabe meelespidamiseks, mis aitab teil meeles pidada, miks toode teile meeldis või ei meeldinud.",
      },
      {
        question: "Millist teavet saan toodete kohta salvestada?",
        answer:
          "Saate salvestada hinnanguid (1–5 tärni), tekstilisi märkmeid, fotosid, makstud hinda, ostukohta ja kohandatud kategooriaid. See põhjalik teave aitab teil ostude tegemisel teadlikke otsuseid langetada.",
      },
      {
        question: "Kas ma saan luua ostunimekirju?",
        answer:
          "Jah! WasOK võimaldab teil luua ostunimekirju toodetest, mida olete juba hinnanud. See muudab lihtsaks meelespidamise, millised tooted teile meeldisid ja mida soovite uuesti osta.",
      },
      {
        question: "Kuidas ma oma tooteid korraldan?",
        answer:
          "Tooteid saate korraldada kohandatud kategooriate abil. Näiteks võite luua kategooriaid nagu „Snäkid“, „Kohv“, „Nahahooldus“ või „Puhastusvahendid“. See muudab arvustuste sirvimise tüübi järgi lihtsaks.",
      },
      {
        question: "Kas WasOK on tasuta?",
        answer:
          "Jah, WasOK on täiesti tasuta alla laadida ja kasutada. Rakenduse siseseid oste, tellimusi ega varjatud tasusid ei ole. Usume, et kõigil peaks olema juurdepääs privaatsele viisile oma tooteeelistuste meelespidamiseks.",
      },
      {
        question: "Kas WasOK on ligipääsetav?",
        answer:
          "WasOK on loodud kasutatavaks võimalikult paljudele inimestele. Rakendus sisaldab ligipääsetavuse funktsioone, nagu ekraanilugeja tugi, skaleeritav tekst ja valikuline kõrge kontrastsuse režiim.",
      },
      {
        question: "Mis juhtub, kui ma rakenduse desinstallin?",
        answer:
          "Kuna kõik andmed salvestatakse kohalikult teie seadmesse, kustutab rakenduse desinstallimine kõik teie tootearvustused, märkmed ja ostunimekirjad. Enne desinstallimist eksportige kindlasti oma andmed, kui soovite varukoopiat säilitada.",
      },
      {
        question: "Kas ma saan oma andmeid eksportida?",
        answer:
          "Jah, WasOK võimaldab teil oma andmeid varundamise eesmärgil eksportida. Saate eksportida kõik oma arvustused failina, mille saate salvestada oma seadmesse või soovitud pilvsalvestusse.",
      },
      {
        question: "Kas WasOK jälgib mu asukohta?",
        answer:
          "Ei, WasOK ei jälgi teie asukohta. Kuigi saate käsitsi sisestada poe nime, kust toote ostsite, ei kasuta rakendus GPS-i ega asukohateenuseid.",
      },
      {
        question: "Kas ma saan WasOKi kasutada mitmes seadmes?",
        answer:
          "Praegu ei sünkrooni WasOK seadmete vahel, kuna kõik andmed salvestatakse kohalikult. Igal seadmel on oma eraldi toodete ja arvustuste andmebaas.",
      },
      {
        question: "Mida teha, kui vöötkood ei skanni?",
        answer:
          "Kui vöötkood ei skanni, veenduge, et see on hästi valgustatud ja fookuses. Võite proovida ka kaameraläätse puhastada. Kui vöötkood on kahjustatud või ebaselge, võib teil olla võimalik vöötkoodi number käsitsi sisestada.",
      },
    ],
    cta: {
      heading: "Kas teil on veel küsimusi?",
      body: "Võtke ühendust meie tugimeeskonnaga — aitame teid hea meelega.",
      button: "Võta ühendust toega",
    },
  },
  support: {
    pageTitle: "Tugi",
    seoTitle: "Tugi — WasOK",
    seoDescription:
      "Saage abi WasOKiga: võtke ühendust toega, teatage vigadest ja jagage tagasisidet.",
    getHelp: {
      title: "Küsi abi",
      body: "Oleme siin, et aidata teil WasOKist maksimumi võtta. Kui teil on probleeme või küsimusi, on meil teie abistamiseks mitmeid ressursse.",
    },
    faq: {
      title: "Korduma kippuvad küsimused",
      body: "Enne meiega ühenduse võtmist vaadake meie KKK jaotist, kus vastame WasOKi kohta kõige sagedamini esitatud küsimustele. Sealt leiate üksikasjalikku teavet selle kohta, kuidas rakendus töötab, privaatsuse, andmete salvestamise ja muu kohta.",
    },
    contact: {
      title: "Võta ühendust toega",
      body: "Kui te ei leia otsitud vastust, on meie tugimeeskond valmis aitama. Võite meiega ühendust võtta:",
      emailLabel: "E-post:",
      responseTime: "Vastame tavaliselt 24–48 tunni jooksul",
    },
    bugs: {
      title: "Vigadest teatamine",
      body: "Leidsite vea? Hindame teie abi WasOKi paremaks muutmisel. Veast teatades lisage palun:",
      items: [
        "Probleemi üksikasjalik kirjeldus",
        "Probleemi taasesitamise sammud",
        "Teie seadme mudel ja Androidi versioon",
        "Ekraanipildid või ekraanisalvestused, kui võimalik",
      ],
      sendPrefix: "Saatke veateated aadressile:",
    },
    featureRequests: {
      title: "Funktsioonisoovid",
      bodyBefore:
        "Kas teil on idee uue funktsiooni jaoks? Tahaksime sellest kuulda! Saatke oma ettepanekud aadressile",
      bodyAfter:
        ". Kuigi me ei saa täita iga soovi, kaalume tulevaste uuenduste planeerimisel hoolikalt kogu tagasisidet.",
    },
    knownIssues: {
      title: "Teadaolevad probleemid",
      body: "Oleme praegu teadlikud järgmistest probleemidest ja töötame lahenduste kallal:",
      items: [
        "Mõned vöötkoodid ei pruugi halva valgustuse korral skannida — proovige kasutada taskulampi",
        "Väga pikkade tootemärkmete salvestamine võib vanematel seadmetel hetke aega võtta",
        "Pisipildid võivad kõrge eraldusvõimega ekraanidel pikslilised paista",
      ],
    },
    appUpdates: {
      title: "Rakenduse uuendused",
      body: "Avaldame regulaarselt uuendusi uute funktsioonide, täiustuste ja veaparandustega. Hoidke kindlasti WasOK Google Play poe kaudu ajakohasena, et saada uusimaid täiustusi.",
    },
    community: {
      title: "Kogukond",
      body: "Liituge meie kasutajate kogukonnaga, kes teevad WasOKiga targemaid ostuotsuseid. Jagage vihjeid, esitage küsimusi ja looge ühendust teiste kasutajatega meie sotsiaalmeediakanalites.",
    },
    emergency: {
      title: "Kiireloomuline tugi",
      body: 'Kui teil on kriitiline probleem, mis takistab rakenduse kasutamist, märkige oma e-kirja teemareale „URGENT“ ja me seame teie taotluse prioriteediks.',
    },
    cta: {
      heading: "Vajate ikka veel abi?",
      body: "Meie tugimeeskond on teie jaoks olemas. Ärge kartke meiega ühendust võtta mis tahes küsimuste või murede korral.",
      button: "Saada e-kiri toele",
    },
  },
  advertising: {
    pageTitle: "Reklaam ja monetiseerimine",
    seoTitle: "Reklaam — WasOK",
    seoDescription: "Kuidas WasOK suhtub reklaami ja monetiseerimisse.",
    approach: {
      title: "Meie lähenemine",
      body: "WasOKis usume, et teie ostuharjumused ja tootearvamused on privaatsed ja isiklikud. Meie ärimudel peegeldab seda põhiväärtust.",
    },
    noAds: {
      title: "Reklaamideta",
      body: "WasOK ei kuva mingeid reklaame. Me ei näita teile kunagi reklaame, mis põhinevad skannitud toodetel, antud hinnangutel või muudel rakenduses loodud andmetel. Teie kogemus WasOKiga on täiesti reklaamivaba.",
    },
    noDataSelling: {
      title: "Andmeid ei müüda",
      body: "Me ei müü, üüri ega jaga teie andmeid reklaamijate, andmemaaklerite ega kolmandate osapooltega. Kuna kõik teie andmed salvestatakse kohalikult teie seadmesse, pole meil isegi ligipääsu neile. Teie tootearvustused, ostunimekirjad ja märkmed kuuluvad ainult teile.",
    },
    noTracking: {
      title: "Jälgimiseta",
      body: "WasOK ei kasuta jälgimispiksleid, analüüsiteenuseid ega muud tehnoloogiat, mis jälgib teie käitumist või jagab teavet kolmandate osapooltega. Me ei jälgi, milliseid tooteid skannite, millistes poodides käite ega kuidas rakendust kasutate.",
    },
    sustainability: {
      title: "Kuidas me jätkusuutlikuks jääme",
      body: "Võite mõelda, kuidas me hoiame WasOKi tasuta ilma reklaamide või andmete müügita. Meie lähenemine on lihtne:",
      items: [
        {
          label: "Tasuta ja avatud:",
          text: "WasOK on kõigile tasuta kasutamiseks, ilma premium-tasandite või tasumüüridata",
        },
        {
          label: "Tõhus toimimine:",
          text: "Hoiame kulud madalad, ehitades tõhusat privaatsusele keskenduvat tarkvara",
        },
        {
          label: "Valikulised annetused:",
          text: "WasOKi armastavad kasutajad saavad meid toetada vabatahtlike annetustega",
        },
        {
          label: "Avatud lähtekood:",
          text: "Võime pakkuda organisatsioonidele konsultatsiooni- või tellimustöö teenuseid",
        },
      ],
    },
    noAffiliate: {
      title: "Partnerlinke pole",
      body: "WasOK ei kasuta partnerlinke ega saa jaemüüjatelt vahendustasu. Kui skannite toote, ei suuna me teid seda kuskil ostma. Rakendus on mõeldud ainult teie isiklike arvestuste pidamiseks ja otsuste tegemiseks.",
    },
    noPromotions: {
      title: "Toodete reklaamimist pole",
      body: "Me ei võta brändidelt ega tootjatelt vastu makseid nende toodete reklaamimiseks. WasOK ei soovita kunagi tooteid, ei tõsta esile teatud brände ega mõjuta teie hinnanguid kuidagi. Teie arvamused kuuluvad ainult teile.",
    },
    partnerships: {
      title: "Kolmandate osapoolte partnerlused",
      body: "WasOK ei tee koostööd turundusettevõtete, andmete koondajate ega reklaamivõrgustikega. Tegutseme sõltumatult ja seame teie privaatsuse kõige olulisemaks.",
    },
    future: {
      title: "Tulevikuplaanid",
      body: "Oleme pühendunud hoidma WasOKi reklaamivaba ja privaatsusele keskendunud. Kui meil peaks tulevikus vaja minema jätkusuutlikku ärimudelit, siis me:",
      items: [
        "Teatame kõikidest muudatustest aegsasti ette",
        "Ei tee kunagi kompromisse privaatsuse ega andmeturbe osas",
        "Pakume alati võimalust kasutada rakendust ilma jälgimise või reklaamideta",
        "Kuulame kasutajate tagasisidet ja muresid",
      ],
    },
    supporting: {
      title: "WasOKi toetamine",
      body: "Kui armastate WasOKi ja soovite toetada meie missiooni pakkuda privaatsusele keskenduvat ostumälu, saate:",
      items: [
        "Rääkida sõpradele ja perele rakendusest",
        "Jätta positiivse hinnangu Google Play poes",
        "Jagada meiega oma tagasisidet ja ettepanekuid",
        "Kaaluda vabatahtliku annetuse tegemist (kui see on saadaval)",
      ],
    },
    cta: {
      heading: "Küsimusi meie põhimõtete kohta?",
      body: "Oleme läbipaistvad selle osas, kuidas WasOK toimib. Kui teil on küsimusi meie lähenemise kohta privaatsusele, monetiseerimisele või jätkusuutlikkusele, võtke palun ühendust.",
      button: "Võta meiega ühendust",
    },
  },
};
